import { createReducer } from '@reduxjs/toolkit';

import { TYPES } from '../../common/constants';

const fetchConstructionStagesDone = (_, { payload }) => {
  
  return payload
};

const clearConstructionStages = () => {
  return []
}
const initialState = [];

export default createReducer(initialState, {
  [TYPES.FETCH_CONSTRUCTION_STAGES_DONE]: fetchConstructionStagesDone,
  [TYPES.CLEAR_CONSTRUCTION_STAGES_DONE]: clearConstructionStages
});
